import { Navigate, useLocation, useParams } from "react-router-dom";

export function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const location = useLocation();
  const splat = params["*"];
  const target = `${to}${splat ? `/${splat}` : ""}${location.search}`;

  return <Navigate replace to={target} />;
}
